<script lang="ts">
  import SelectChip from "./SelectChip.svelte"
  import { getSelectRootContext } from "./SelectRoot.svelte"

  let { contentRef = $bindable(), hiddenChips = $bindable(0) } = $props()

  const rootCtx = getSelectRootContext()

  let chipRefs: HTMLDivElement[] = $state([])

  $effect(() => {
    hiddenChips = chipRefs.filter((chip) => {
      if (chip && contentRef) {
        const { right: contentRight } = contentRef.getBoundingClientRect()
        const { right: chipRight } = chip.getBoundingClientRect()
        return chipRight > contentRight
      }

      return false
    }).length
  })

  const selected = $derived(
    Array.isArray(rootCtx.selected) ? rootCtx.selected : []
  )
</script>

{#each selected as selectedItem, index}
  <SelectChip label={selectedItem.label} bind:chipRef={chipRefs[index]} />
{/each}
